import _ from "lodash";

import { CashierBetStateEnum, CashierBetStateViewEnum } from "@cashier/src/common/constants/enums/bet";
import { GoldenRaceGameGroupTypeEnum } from "@cashier/src/common/constants/enums/casino";

const statusMap = {
	OPEN: CashierBetStateEnum.Accepted,
	WON: CashierBetStateEnum.Won,
	LOST: CashierBetStateEnum.Lost,
	CANCELLED: CashierBetStateEnum.Rejected,
	PAID_OUT: CashierBetStateEnum.CashOut,
	LOCKED: CashierBetStateEnum.NotResulted,
};

const getBetsWithEvents = (betInfo, winInfo) => {
	const winEvents = winInfo?.AdditionalInfo.Details.events;

	return betInfo.AdditionalInfo.Details.events.reduce((acc, event) => {
		const winEvent = winEvents?.find(item => item.eventId === event.eventId);

		const betsInsideEvent = event.bets.map(bet => {
			const wonBet = winEvent?.bets.find(item => item.lineId === bet.lineId);
			return {
				...bet,
				winInfo: wonBet,
				winEvent: winEvent ? _.omit(winEvent, "bets") : null,
				event: _.omit(event, "bets"),
			};
		});

		return [...acc, ...betsInsideEvent];
	}, []);
};

const mapSelection = selection => {
	const originalStatus = selection.winInfo?.status || selection.status;
	const hasNumbers = selection.event.GameGroupName === GoldenRaceGameGroupTypeEnum.Lottery && selection.betParam;

	const status = statusMap[originalStatus] || CashierBetStateEnum.Accepted;

	return {
		id: selection.event.eventId + selection.oddId,
		name: selection.event.playlistDescription,
		status,
		statusName: CashierBetStateViewEnum[status],
		selectionName: `${selection.event.eventName ? `${selection.event.eventName} ` : ""}${
			selection.event.playlistDescription
		}`,
		marketName: selection.marketFullName,

		numbers: hasNumbers ? selection.betParam.split(",") : null,
		rawNumbers: hasNumbers ? selection.betParam : null,

		price: selection.oddValue,
		amount: selection.stake,
		startTime: selection.event.eventTime,

		originalStatusName: originalStatus,
	};
};

export const mapGoldenRaceSelections = ticket => {
	const { casinoInfo } = ticket;

	const originalSelections = casinoInfo.BetMultiplyInfo.flatMap((betInfo, betIndex) => {
		const betId = betInfo.TransactionId?.split("stage")[0]; // TODO remove someday

		const winInfo = betId
			? casinoInfo.WinMultiplyInfo?.find(winDetails => {
					const winId = winDetails.TransactionId?.split("stage")[0];
					return betId === winId;
			  })
			: casinoInfo.WinMultiplyInfo?.[betIndex];

		return getBetsWithEvents(betInfo, winInfo);
	});

	return originalSelections.map(mapSelection);
};

export const mapGoldenRaceNestedBets = ticket => {
	const { casinoInfo } = ticket;

	const selections = casinoInfo.BetMultiplyInfo[0].AdditionalInfo.Details.events.flatMap(event => event.bets);

	const { systemBets = [] } = casinoInfo.BetMultiplyInfo[0].AdditionalInfo.Details;

	return systemBets.map(bet => {
		const isMultiple = bet.grouping === selections.length;

		if (isMultiple) {
			return {
				betTypeName: "Multiple",
				price: selections.reduce((acc, selection) => +selection.oddValue * acc, 1),
				amount: bet.stake,
				possibleWin: bet.winningData.maxWinning + (bet.winningData.minBonus || 0),
			};
		}

		return {
			betTypeName: "System",
			optionValue: `${bet.grouping}/${selections.length}`,
			amount: bet.stake,
			possibleWin: bet.winningData.maxWinning + (bet.winningData.minBonus || 0),
		};
	});
};
